const useBaseUrl = () => {
    const url = window.location.href;
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname;
 
    return hostname
}

export default useBaseUrl;